// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Grid as MaterialUIGrid,
    GridProps as MaterialUIGridProps
} from '@material-ui/core'

interface GridBaseProps { }
export type GridProps = Partial<MaterialUIGridProps> & GridBaseProps

export const Grid: FC<GridProps> = ({ ...props }) => {
    return <MaterialUIGrid {...props}></MaterialUIGrid>
}
